module.exports = __webpack_public_path__ + "img/h-1.e4fa11fb.png";